import type { UploadVariant } from './types';

/** A ready-made `<Upload>` configuration for one upload zone. */
export type UploadPreset = {
  variant: UploadVariant;
  /** HTML accept string — used for the picker hint AND `isFileAccepted` enforcement. */
  accept: string;
  maxSizeMb: number;
  maxCount: number;
  helpText: string;
};

/**
 * Shared upload-zone presets. Single source for the D3 / story #102085 constraints
 * and the Figma help copy (node 652-194520). Spread into `<Upload>` / `<UploadField>`:
 *   <Upload {...UPLOAD_PRESETS.componentImages} onUpload={uploader} />
 */
export const UPLOAD_PRESETS: Record<'componentImages' | 'installationGuide', UploadPreset> = {
  componentImages: {
    variant: 'image',
    accept: 'image/jpeg,image/png,.jpg,.jpeg,.png',
    maxSizeMb: 5,
    maxCount: 5,
    helpText: 'Add up to 5 images (JPG, JPEG or PNG)\nMax 5MB each.',
  },
  installationGuide: {
    variant: 'document',
    accept:
      'video/mp4,video/quicktime,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.mp4,.mov,.pdf,.doc,.docx',
    maxSizeMb: 100,
    maxCount: 5,
    helpText: 'Add up to 5 files (Video/PDF/DOC)\nMax 100MB each',
  },
};
